import React, { Component } from 'react';
import UserList from '../User/UserList'
import HardwareList from '../Hardware/BrandList'

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Icon from '@material-ui/core/Icon'
import Drawer from '@material-ui/core/Drawer'

import './Main.css';

class Main extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selected: 'hardware',
            open: false,
        }
    }

    onSelectView = (selected) => {
        this.setState({ selected, open: !this.state.open })
    }

    onToggleDrawer = () => {
        this.setState({ open: !this.state.open })
    }

    render() {
        const { selected } = this.state
        return (
            <div className="main">
                <Icon onClick={this.onToggleDrawer} className="menu-icon">menu</Icon>
                <Drawer
                    open={this.state.open}
                    variant="temporary"
                    onClose={this.onToggleDrawer}
                >
                    <List>
                        <ListItem
                            onClick={() => this.onSelectView('home')}
                            selected={selected === 'home'}
                            button={true}
                            >
                            <ListItemIcon><Icon>home</Icon></ListItemIcon>
                            <ListItemText>Home</ListItemText>
                        </ListItem>
                        <ListItem
                            onClick={() => this.onSelectView('hardware')}
                            selected={selected === 'hardware'}
                            button={true}
                        >
                            <ListItemIcon><Icon>router</Icon></ListItemIcon>
                            <ListItemText>Hardware</ListItemText>
                        </ListItem>
                        <ListItem
                            onClick={() => this.onSelectView('userList')}
                            selected={selected === 'userList'}
                            button={true}
                        >
                            <ListItemIcon><Icon>people</Icon></ListItemIcon>
                            <ListItemText>Users</ListItemText>
                        </ListItem>
                    </List>
                </Drawer>
                {selected === 'hardware' && <HardwareList />}
                {selected === 'userList' && <UserList />}
                {selected === 'home' && <div>Home</div>}
            </div>
        );
    }
}

export default Main;



// WEBPACK FOOTER //
// ./src/components/Main/Main.js